import { Box, Drawer, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { Close } from "@mui/icons-material";

const CustomModal = ({ open, onClose, title, children }) => {
  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      variant="temporary"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          m: 2,
          mr: 4,
          width: smScreen ? "80%" : "100%",
          maxWidth: smScreen ? 400 : 900,
          backgroundColor: "#fff",
          boxShadow: 24,
          overflow: "hidden",
          height: "95%",
          zIndex: 99999999,
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,0.6)",
        },
      }}
    >
      <Box sx={{ p: 2, overflowY: "auto", height: "100%" }}>
        {/* Header */}
        <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
          <Typography
            sx={{
              color: colors.primary,
              fontFamily: "Mulish-ExtraBold",
              fontSize: "24px",
              mb: 1,
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              height: "40px",
              width: "40px",
              borderRadius: "9px",
              backgroundColor: "rgba(247,132,25,0.05)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "rgba(247,132,25,0.15)",
              },
            }}
            onClick={onClose}
          >
            <Close sx={{ color: colors.secondary, fontSize: "30px" }} />
          </Box>
        </Stack>

        {children}
      </Box>
    </Drawer>
  );
};

export default CustomModal;
